export default `
mutation plano(
    $idProposta: String
    $tipoPlano: String
    $produtoId: String
    $valor: Float
    $valorRecargaPrePago: Int
    $captchaResponse: String
    $codigoPromocional: String
  ) {
    planoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        pedido: {
          plano: { tipoPlano: $tipoPlano, produtoId: $produtoId, valor: $valor, valorRecargaPrePago: $valorRecargaPrePago, codigoPromocional: $codigoPromocional }
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
